import React from 'react'
import ActionGroup from './ActionGroup'
import {connect} from 'react-redux'
import Action from './Action'
import FilterBar from './FilterBar'
import styled from 'styled-components'

const Sidebar = styled.div
`
    width:20%;
    clear:both;
    height:calc(100vh - 55px);
    float:left;
    position:relative;
    box-sizing:border-box;
    border-right:3px solid black;
    overflow-y:hidden;
    
`

const SidebarUl = styled.ul
    `
    margin:0;
    padding:0;
    `
    const ScrollContainer = styled.div
    `
    height:calc(100% - 42px);    
    overflow-y:auto;
    `


const ActionList = ({actions}) => {
    var actionsArr = [];
    actions.map((actionGroup, name) => {
        actionsArr.push(<ActionGroup key={name} name={name}/>)
        actionGroup.forEach(function(action, name){
            actionsArr.push(<Action key={name}  actionName={name} action={action}/>)
        }
        )
        return true
    });

    return(
        <Sidebar>
    <FilterBar />
    <ScrollContainer>
    <SidebarUl className="actionList">
        {actionsArr}
    </SidebarUl>
    </ScrollContainer>
        </Sidebar>
        )
}

function mapStateToProps(state){
    return{
        actions : state.actionList
    }
}

export default connect(mapStateToProps)(ActionList)

